import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Platform } from 'react-native';
import Colors from '../../constants/Colors';
import CS from '../../constants/Styles';
import { url } from '../../constants/DevProd';
import * as rtApi from '../../components/Api';
import { BackgroundGradient, Loader, TextInputContainer, Validate, Button, PhotosDocumentsAddPreviewGrid, Storage } from '../../components';
import UserState from '../../src/contexts/UserState';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import { useLinkTo } from '@react-navigation/native';
import { FontAwesome5 } from '@expo/vector-icons';
// import * as WebBrowser from 'expo-web-browser';
import { getImageFieldsForUpload } from '../../utils/Functions';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

const DisputeQuestions = ({ navigation, route }) => {
  const [user, setUser] = React.useContext(UserState);
  const [loading, setLoading] = React.useState(false);
  const [isContractor, setIsContractor] = React.useState(false);

  const [customerContractorText, setCustomerContractorText] = React.useState('contractor');
  const insets = useSafeAreaInsets();
  // const [introBlurb, setIntroBlub] = React.useState('Please answer the questions below to give our mediators greater context. Your answers will NOT be shared with your contractor.');
  // const [questions, setQuestions] = React.useState([
  //   "Why aren't you satisfied with the contractor's work? What was your understanding or expectation?",
  //   "Where do you think things deteriorated between you and the contractor?",
  //   "What would you like to see the contractor do in order for you to release the funds? What would represent the most ideal situation?",
  //   "Where is the line in the sand for you? What is the bare minimum it would take for you to release even part of the funds?",
  // ]);
  const [answer1, setAnswer1] = React.useState('');
  const [answer2, setAnswer2] = React.useState('');
  const [answer3, setAnswer3] = React.useState('');
  const [answer4, setAnswer4] = React.useState('');
  const [photos, setPhotos] = React.useState([]);

  let scrollViewRef = null;
  const linkTo = useLinkTo();

  const [isInvalid, setIsInvalid] = React.useState({
    answer1: false,
    answer2: false,
    answer3: false,
    answer4: false
  });
  let textInputs = {
    answer1: React.useRef(null),
    answer2: React.useRef(null),
    answer3: React.useRef(null),
    answer4: React.useRef(null),
  };

  React.useEffect(() => {
    getAgreement();
  }, []);

  React.useEffect(() => {
    if (isContractor) {
      setCustomerContractorText('customer');
    }
  }, [isContractor]);

  const getAgreement = () => {
    setLoading(true);
    rtApi.get(`agreements/${route.params.agreementId}`,)
      .then(data => {
        console.log(data);
        setIsContractor(data.agreement.contractor_id === user.id ? true : false)
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  // React.useEffect(() => {
  //   if (isContractor) {
  //     setIntroBlub('Please answer the questions below to give our mediators greater context. Your answers will NOT be shared with the homeowner.');
  //     setQuestions([
  //       "Why do you believe the funds should be released? What was your understanding or expectation?",
  //       "Where do you think things deteriorated between you and the homeowner?",
  //       "What are you willing to do to get the homeowner to release the funds?",
  //       "Would you be willing to accept part of the payment? 'Cutting your losses' so to speak of. What is the minimum you would accept?",
  //     ])
  //   }
  // }, [isContractor]);


  const onChangeAnswer1 = (text) => {
    if (isInvalid.answer1 && Validate.Blank(text)) {
      setIsInvalid(prevState => { return { ...prevState, answer1: false } });
    }
    setAnswer1(text);
  };
  const onChangeAnswer2 = (text) => {
    if (isInvalid.answer2 && Validate.Blank(text)) {
      setIsInvalid(prevState => { return { ...prevState, answer2: false } });
    }
    setAnswer2(text);
  };
  const onChangeAnswer3 = (text) => {
    if (isInvalid.answer3 && Validate.Blank(text)) {
      setIsInvalid(prevState => { return { ...prevState, answer3: false } });
    }
    setAnswer3(text);
  };
  const onChangeAnswer4 = (text) => {
    if (isInvalid.answer4 && Validate.Blank(text)) {
      setIsInvalid(prevState => { return { ...prevState, answer4: false } });
    }
    setAnswer4(text);
  };

  const checkAnswers = async () => {
    // answer1
    if (!Validate.Blank(answer1)) {
      setIsInvalid(prevState => { return { ...prevState, answer1: true } });
      textInputs.answer1.current.focus();
      scrollViewRef.scrollToPosition(0, 60);
      return;
    }
    // answer2
    if (!Validate.Blank(answer2)) {
      setIsInvalid(prevState => { return { ...prevState, answer2: true } });
      textInputs.answer2.current.focus();
      return;
    }
    // answer3
    if (!Validate.Blank(answer3)) {
      setIsInvalid(prevState => { return { ...prevState, answer3: true } });
      textInputs.answer3.current.focus();
      return;
    }
    // answer4
    if (!Validate.Blank(answer4)) {
      setIsInvalid(prevState => { return { ...prevState, answer4: true } });
      textInputs.answer4.current.focus();
      return;
    }

    // post then link with freshdeskid
    saveQuestions();
  }

  const buildFormData = () => {
    let fd = new FormData();
    fd.append('agreement_id', route.params.agreementId);
    fd.append('answer1', answer1);
    fd.append('answer2', answer2);
    fd.append('answer3', answer3);
    fd.append('answer4', answer4);
    
    fd.append('image_count', photos.length);
    photos.forEach((p, i) => {
      console.log('image', p);
      if (Platform.OS !== 'web') {
        let photoDetails = getImageFieldsForUpload(p.uri);
        fd.append(`image${i + 1}`, {
          uri: p.uri,
          name: photoDetails.filename,
          type: photoDetails.type,
        });
      } else {
        fd.append(`image${i + 1}`, p.file)
      }
    });

    return fd;
  }

  const saveQuestions = () => {
    setLoading(true);
    let fd = buildFormData();
    console.log('saving dispute questions');
    rtApi.post(`agreements/${route.params.agreementId}/file-dispute`, fd)
    .then(data => {
      console.log(data);
      if (data.result) {
        afterSave(data);
      }
    })
    .catch((error) => {
      console.log(error);
    })
    .finally(() => {
      setLoading(false);
    });
  }

  const afterSave = async (data) => {
    await Storage.setItem('rtDisputeFees', JSON.stringify(data.fee));
    linkTo(`/dispute/${route.params.agreementId}/${data.fresh_desk_id}/payment`);
  }

  const goBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      linkTo(`/howdisputeswork/${route.params.agreementId}`);
    }
  }

  const renderInputs = (index, style) => {
    // style = style === undefined ? {} : style;
    switch (index){
      case 0:
        return (
          <TextInputContainer
            placeholder='Type your answer'
            textContentType='none'
            onChangeText={(t) => onChangeAnswer1(t)}
            inputRef={textInputs.answer1}
            isInvalid={isInvalid.answer1}
            onSubmitEditing={() => textInputs.answer2.current.focus()}
            returnKeyType='next'
            value={answer1}
            multiline={true}
            inputStyle={styles.answer}
            inputContainerStyle={style}
            numberOfLines={3}
          />
        )
      case 1:
        return (
          <TextInputContainer
            placeholder='Type your answer'
            textContentType='none'
            onChangeText={(t) => onChangeAnswer2(t)}
            inputRef={textInputs.answer2}
            isInvalid={isInvalid.answer2}
            onSubmitEditing={() => textInputs.answer3.current.focus()}
            returnKeyType='next'
            value={answer2}
            multiline={true}
            inputStyle={styles.answer}
            inputContainerStyle={style}
            numberOfLines={3}
          />
        )
      case 2:
        return (
          <TextInputContainer
            placeholder='Type your answer'
            textContentType='none'
            onChangeText={(t) => onChangeAnswer3(t)}
            inputRef={textInputs.answer3}
            isInvalid={isInvalid.answer3}
            onSubmitEditing={() => textInputs.answer4.current.focus()}
            returnKeyType='next'
            value={answer3}
            multiline={true}
            inputStyle={styles.answer}
            inputContainerStyle={style}
            numberOfLines={3}
          />
        )
      case 3:
        return (
          <TextInputContainer
            placeholder='Type your answer'
            textContentType='none'
            onChangeText={(t) => onChangeAnswer4(t)}
            inputRef={textInputs.answer4}
            isInvalid={isInvalid.answer4}
            // onSubmitEditing={}
            returnKeyType='done'
            value={answer4}
            multiline={true}
            inputStyle={styles.answer}
            inputContainerStyle={style}
            numberOfLines={3}
          />
        )
    }
  }

  return (
    <View style={CS.safe}>
      <BackgroundGradient />
      <Loader animating={loading} />
      <View style={CS.innerContainer}>
        <KeyboardAwareScrollView ref={ref => scrollViewRef = ref} style={styles.container} contentContainerStyle={[styles.innerContainer, { paddingTop: insets.top, paddingBottom: insets.bottom }]} keyboardDismissMode='on-drag'>
          <View style={styles.titleContainer}>
            <Text style={[CS.mediumTitle, CS.lightText, CS.centerText, CS.noMargin]}>Dispute Questions</Text>
            <TouchableOpacity onPress={goBack} style={styles.backArrow}>
              <FontAwesome5 name="arrow-left" size={24} color="white" />
            </TouchableOpacity>
          </View>
          {route.params.initial === 'yes'
          ?
            <>
              <View style={styles.section}>
                <Text style={[CS.smallText, CS.lightBlueText, styles.intro]}>These answers will be shared with your {customerContractorText}.</Text>
                <Text style={[CS.smallText, CS.lightText, styles.question]}>Why are you refusing to release the funds?</Text>
                {renderInputs(0)}
                <Text style={[CS.smallText, CS.lightText, styles.question]}>What would you like to see done in order for you to release the funds? What would represent the most ideal situation?</Text>
                {renderInputs(1, { marginBottom: 0 })}
              </View>

              <View style={styles.section}>
                <Text style={[CS.smallText, CS.lightBlueText, styles.intro]}>These answers will NOT be shared with your contractor, they will give your dispute resolution negotiator greater context.</Text>
                <Text style={[CS.smallText, CS.lightText, styles.question]}>Where do you think things deteriorated between you and your {customerContractorText}?</Text>
                {renderInputs(2)}
                <Text style={[CS.smallText, CS.lightText, styles.question]}>What is the bare minimum it would take for you to release even part of the funds? Where is the line in the sand for you?</Text>
                {renderInputs(3, { marginBottom: 0 })}
              </View>
            </>
          :
            <>
              <Text style={[CS.smallText, CS.lightBlueText, styles.intro]}>Please answer the questions below to give your dispute resolution negotiator greater context. These answers will NOT be shared with the {customerContractorText}.</Text>
              <Text style={[CS.smallText, CS.lightText, styles.question]}>Why do you believe the funds should be released? What was your understanding or expectation?</Text>
              {renderInputs(0)}
              <Text style={[CS.smallText, CS.lightText, styles.question]}>Where do you think things deteriorated between you and your {customerContractorText}?</Text>
              {renderInputs(1)}
              <Text style={[CS.smallText, CS.lightText, styles.question]}>What are you willing to do to get the funds released?</Text>
              {renderInputs(2)}
              <Text style={[CS.smallText, CS.lightText, styles.question]}>What is the minimum you would accept? Would you be willing to accept part of the payment? 'Cutting your losses' so to speak.</Text>
              {renderInputs(3)}
            </>
          }
          
          <View style={{ marginBottom: 20 }}>
            <Text style={[CS.smallText, CS.lightText, styles.question]}>Photos Of Work In Dispute</Text>
            <PhotosDocumentsAddPreviewGrid 
              items={photos}
              setItems={setPhotos}
            />
          </View>
          
          <Button text='Continue to Payment' onPress={() => checkAnswers} style={styles.button} />

        </KeyboardAwareScrollView>
      </View>
    </View>
  );

}

const styles = StyleSheet.create({
  container: {
    width: '100%',
  },
  innerContainer: {
    // width: '100%',
    // maxWidth: Platform.OS === 'web' ? 768 : '100%',
    // justifyContent: 'center',
    // alignSelf: 'center',
    // padding:10,
    width: '100%',
    flexGrow: 1,
    alignSelf: 'center',
  },
  titleContainer: {
    marginVertical: 20,
    alignItems: 'center',
  },
  backArrow: {
    position: 'absolute',
    top: 5,
    left: 0,
  },
  intro: {
    marginBottom: 20,
  },
  question: {
    marginBottom: 10,
  },
  answer: {
    height: 80,
  },
  button: {
    marginBottom: 20,
  },
  section: {
    borderRadius: 10,
    padding: 10,
    borderWidth: 1,
    borderColor: Colors.lightBlue,
    backgroundColor: Colors.textInputBackground,
    marginBottom: 20,
  }
});

export default DisputeQuestions;